// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaShoppingCart, FaSearch, FaHeart, FaStar, FaRegStar, FaEye } from "react-icons/fa";
// import { db, ref, auth } from "../firebase";
// import { onValue } from "firebase/database";
// import { onAuthStateChanged } from "firebase/auth";
// import Navbar from "./Navbar";
// import img1 from "../assets/img1.jpg";
// import img2 from "../assets/img2.jpg";
// import img3 from "../assets/img3.jpg";
// import ProductSlider from "./Slider";
// import Footer from "./Footer";

// const HomePage = () => {
//   const navigate = useNavigate();
//   const [featuredProducts, setFeaturedProducts] = useState([]);
//   const [newArrivals, setNewArrivals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [cartCount, setCartCount] = useState(0);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [screenSize, setScreenSize] = useState({
//     isMobile: window.innerWidth < 768,
//     isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
//     isDesktop: window.innerWidth >= 1024,
//     isLargeDesktop: window.innerWidth >= 1440,
//     width: window.innerWidth,
//     height: window.innerHeight
//   });

  
//   // Responsive breakpoints handler
//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       const height = window.innerHeight;
//       setScreenSize({
//         isMobile: width < 768,
//         isTablet: width >= 768 && width < 1024,
//         isDesktop: width >= 1024,
//         isLargeDesktop: width >= 1440,
//         width,
//         height
//       });
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Luxury color palette
//   // const colors = {
//   //   primary: "#1a1a1a",       // Rich black
//   //   secondary: "#f5f5f5",     // Off-white
//   //   accent: "#c19a6b",        // Gold
//   //   textDark: "#333333",
//   //   textLight: "#ffffff",
//   //   background: "#f9f7f5",    // Warm ivory
//   //   highlight: "rgba(193, 154, 107, 0.2)",
//   //   border: "rgba(0, 0, 0, 0.1)",
//   //   gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//   //   glass: "rgba(255, 255, 255, 0.25)",
//   //   shadow: "rgba(0, 0, 0, 0.1)"
//   // };








// const colors = {
//   primary: "#1a1a1a",       // Rich black
//   secondary: "#f5f5f5",     // Off-white
//   accent: "#c19a6b",        // Gold
//   textDark: "#333333",
//   textLight: "#ffffff",
//   background: "#f9f7f5",    // Warm ivory
//   highlight: "rgba(193, 154, 107, 0.2)",
//   border: "rgba(0, 0, 0, 0.1)",
//   gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//   glass: "rgba(255, 255, 255, 0.25)",
//   shadow: "rgba(0, 0, 0, 0.1)",

//   // Extracted from logo
//   logoDarkGray: "#272424",
//   logoBrightRed: "#ed3237",
//   logoCharcoal: "#373c3c",
//   logoDeepRed: "#8f2d30",
//   logoMediumGray: "#646262",
//   logoVeryDarkGray: "#201d1d",
//   logoPurple: "#6a0dad" // Estimated purple for SURYAWANSHI text
// };



  
//   // Check authentication state
//   useEffect(() => {
//     const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         const userData = {
//           uid: user.uid,
//           displayName: user.displayName || user.email.split("@")[0],
//           email: user.email,
//           photoURL: user.photoURL || "/default-user.png",
//         };
//         setCurrentUser(userData);
//         localStorage.setItem("user", JSON.stringify(userData));
//       } else {
//         setCurrentUser(null);
//         localStorage.removeItem("user");
//       }
//     });

//     // Load products
//     const productsRef = ref(db, "Watch/admin/products");
//     const unsubscribeProducts = onValue(productsRef, (snapshot) => {
//       const productsData = snapshot.val();
//       if (productsData) {
//         const productsList = Object.entries(productsData).map(([id, data]) => ({
//           id,
//           ...data,
//           price: parseFloat(data.price),
//           discount: data.discount || 0,
//         }));

//         setFeaturedProducts(productsList.filter((p) => p.featured).slice(0, 6));
//         setNewArrivals(
//           [...productsList]
//             .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//             .slice(0, 6)
//         );
//       }
//       setLoading(false);
//     });

//     // Load cart
//     const cart = JSON.parse(localStorage.getItem("cart")) || [];
//     setCartCount(cart.reduce((total, item) => total + item.quantity, 0));

//     return () => {
//       unsubscribeAuth();
//       unsubscribeProducts();
//     };
//   }, []);

//   const renderRating = (rating) => {
//     return Array(5)
//       .fill()
//       .map((_, i) =>
//         i < Math.floor(rating || 4) ? (
//           <FaStar 
//             key={i} 
//             style={{ 
//               color: colors.accent,
//               fontSize: "0.9rem"
//             }} 
//           />
//         ) : (
//           <FaRegStar 
//             key={i} 
//             style={{ 
//               color: colors.accent,
//               fontSize: "0.9rem"
//             }} 
//           />
//         )
//       );
//   };

//   const handleProductClick = (productId) => {
//     navigate(`/product/${productId}`, {
//       state: {
//         user: currentUser,
//       },
//     });
//   };

//   const addToCart = (product, e) => {
//     e.stopPropagation();
//     const cart = JSON.parse(localStorage.getItem("cart")) || [];
//     const existingItem = cart.find((item) => item.id === product.id);

//     if (existingItem) {
//       existingItem.quantity += 1;
//     } else {
//       cart.push({
//         id: product.id,
//         name: product.name,
//         price: product.price * (1 - (product.discount || 0) / 100),
//         image: product.images?.[0] || "/placeholder-product.jpg",
//         quantity: 1,
//       });
//     }

//     localStorage.setItem("cart", JSON.stringify(cart));
//     setCartCount(cart.reduce((total, item) => total + item.quantity, 0));
//   };

//  const ProductCard = ({ product, index, section = "featured" }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   const [imageLoaded, setImageLoaded] = useState(false);
  
//   return (
//     <div 
//       style={{
//         position: "relative",
//         width: "100%",
//         background: "linear-gradient(145deg, #ffffff, #f8f8f8)",
//         borderRadius: screenSize.isMobile ? "12px" : "20px",
//         overflow: "hidden",
//         boxShadow: isHovered 
//           ? "0 15px 30px rgba(0,0,0,0.12)" 
//           : "0 8px 20px rgba(0,0,0,0.08)",
//         transition: "all 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
//         cursor: "pointer",
//         animation: `cardSlideUp 0.6s ease-out ${index * 0.1}s both`,
//         transform: isHovered && !screenSize.isMobile
//           ? "translateY(-8px)" 
//           : "translateY(0)",
//         border: "1px solid rgba(0,0,0,0.05)"
//       }}
//       onClick={() => handleProductClick(product.id)}
//       onMouseEnter={() => !screenSize.isMobile && setIsHovered(true)}
//       onMouseLeave={() => !screenSize.isMobile && setIsHovered(false)}
//     >
//       {/* Image Container */}
//       <div style={{
//         position: "relative",
//         paddingBottom: "100%", // Square aspect ratio for consistency
//         overflow: "hidden",
//         background: "#f0f0f0"
//       }}>
//         {!imageLoaded && (
//           <div style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: "30px",
//             height: "30px",
//             border: `3px solid ${colors.accent}`,
//             borderTopColor: "transparent",
//             borderRadius: "50%",
//             animation: "spin 1s linear infinite"
//           }}></div>
//         )}
        
//         <img 
//           src={product.images?.[0] || "/placeholder-product.jpg"} 
//           alt={product.name}
//           onLoad={() => setImageLoaded(true)}
//           style={{
//             position: "absolute",
//             top: "0",
//             left: "0",
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             transition: "transform 0.6s ease",
//             transform: isHovered ? "scale(1.08)" : "scale(1)",
//             opacity: imageLoaded ? 1 : 0
//           }} 
//         />
        
//         {/* Discount Badge */}
//         {product.discount > 0 && (
//           <div style={{
//             position: "absolute",
//             top: "10px",
//             left: "10px",
//             background: "linear-gradient(135deg, #ff6b6b, #ee5a24)",
//             color: "white",
//             padding: screenSize.isMobile ? "4px 8px" : "6px 12px",
//             borderRadius: "12px",
//             fontSize: screenSize.isMobile ? "0.7rem" : "0.75rem",
//             fontWeight: "700",
//             boxShadow: "0 4px 12px rgba(238, 90, 36, 0.3)",
//             zIndex: 2
//           }}>
//             -{product.discount}%
//           </div>
//         )}
        
//         {/* Wishlist Icon */}
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             // Add to wishlist logic
//           }}
//           style={{
//             position: "absolute",
//             top: "10px",
//             right: "10px",
//             background: "rgba(255, 255, 255, 0.9)",
//             border: "none",
//             borderRadius: "50%",
//             width: screenSize.isMobile ? "32px" : "36px",
//             height: screenSize.isMobile ? "32px" : "36px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             cursor: "pointer",
//             transition: "all 0.3s ease",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//             zIndex: 2
//           }}
//         >
//           <FaHeart style={{ 
//             color: colors.accent, 
//             fontSize: screenSize.isMobile ? "14px" : "16px" 
//           }} />
//         </button>
//       </div>

//       {/* Content */}
//       <div style={{
//         padding: screenSize.isMobile ? "12px" : "16px",
//         background: "#fff"
//       }}>
//         {/* Product Name */}
//         <h3 style={{
//           fontSize: screenSize.isMobile ? "0.85rem" : "1rem",
//           fontWeight: "600",
//           color: colors.primary,
//           marginBottom: "6px",
//           lineHeight: "1.3",
//           overflow: "hidden",
//           textOverflow: "ellipsis",
//           display: "-webkit-box",
//           WebkitLineClamp: 2,
//           WebkitBoxOrient: "vertical",
//           minHeight: screenSize.isMobile ? "2.2em" : "2.6em"
//         }}>
//           {product.name}
//         </h3>

//         {/* Brand */}
//         <p style={{
//           color: colors.textDark,
//           fontSize: screenSize.isMobile ? "0.7rem" : "0.8rem",
//           marginBottom: "8px",
//           opacity: "0.6",
//           fontWeight: "500",
//           textTransform: "uppercase",
//           letterSpacing: "0.3px"
//         }}>
//           {product.brand}
//         </p>

//         {/* Rating */}
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "3px",
//           marginBottom: "10px"
//         }}>
//           {renderRating(product.rating)}
//           <span style={{
//             fontSize: screenSize.isMobile ? "0.7rem" : "0.75rem",
//             color: colors.textDark,
//             marginLeft: "6px",
//             opacity: "0.6"
//           }}>
//             ({Math.floor(Math.random() * 50) + 10})
//           </span>
//         </div>

//         {/* Price */}
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: "6px"
//         }}>
//           <div style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "6px"
//           }}>
//             <span style={{
//               fontSize: screenSize.isMobile ? "1rem" : "1.1rem",
//               fontWeight: "700",
//               color: colors.primary,
//               background: "linear-gradient(135deg, #667eea, #764ba2)",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent"
//             }}>
//               ₹{(product.price * (1 - product.discount / 100)).toFixed(0)}
//             </span>
            
//             {product.discount > 0 && (
//               <span style={{
//                 fontSize: screenSize.isMobile ? "0.8rem" : "0.85rem",
//                 color: "#999",
//                 textDecoration: "line-through",
//                 opacity: "0.6"
//               }}>
//                 ₹{product.price.toFixed(0)}
//               </span>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };


//   if (loading) {
//     return (
//       <div style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//         backgroundColor: colors.background,
//         flexDirection: "column"
//       }}>
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "16px",
//           color: colors.primary,
//           fontSize: "1.2rem",
//           fontFamily: "'Playfair Display', serif"
//         }}>
//           <div style={{
//             width: "40px",
//             height: "40px",
//             border: `4px solid ${colors.accent}`,
//             borderTopColor: "transparent",
//             borderRadius: "50%",
//             animation: "spin 1s linear infinite"
//           }}></div>
//           Loading Luxury Collection...
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       backgroundColor: colors.background,
//       minHeight: "100vh",
//       fontFamily: "'Montserrat', sans-serif"
//     }}>
//       <Navbar currentUser={currentUser} cartCount={cartCount} />
      
//       {/* Welcome Banner */}
//       {currentUser && (
//         <div style={{
//           backgroundColor: colors.accent,
//           color: colors.textLight,
//           padding: screenSize.isMobile ? "10px 15px" : "8px 0",
//           textAlign: "center",
//           fontWeight: "500",
//           fontSize: screenSize.isMobile ? "0.8rem" : "0.9rem",
//           letterSpacing: screenSize.isMobile ? "0.5px" : "1px",
//           fontFamily: "'Playfair Display', serif",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           flexDirection: "column",
//           animation: "slideInFromTop 0.5s ease-out"
//         }}>
//           Welcome back, {currentUser.displayName}!
//         </div>
//       )}

//       <ProductSlider />

//        <section style={{
//   maxWidth: "1200px",
//   margin: "0 auto",
//   padding: screenSize.isMobile ? "40px 15px" : "60px 20px",
//   overflow: "hidden"
// }}>
//   <div style={{
//     textAlign: "center",
//     marginBottom: screenSize.isMobile ? "30px" : "50px"
//   }}>
//     <h2 style={{
//       fontSize: screenSize.isMobile ? "1.8rem" : "2.5rem",
//       fontWeight: "800",
//       color: colors.textDark,
//       marginBottom: "15px",
//       position: "relative",
//       display: "inline-block",
//       animation: "fadeInUp 0.8s ease-out"
//     }}>
//       Explore Collections
//       <span style={{
//         position: "absolute",
//         bottom: "-10px",
//         left: "50%",
//         transform: "translateX(-50%)",
//         width: "60px",
//         height: "4px",
//         background: colors.gradient,
//         borderRadius: "2px",
//         animation: "lineExpand 0.8s ease-out 0.3s both"
//       }}></span>
//     </h2>
//     <p style={{
//       color: colors.textMuted,
//       fontSize: "1.1rem",
//       maxWidth: "600px",
//       margin: "0 auto",
//       lineHeight: "1.6",
//       animation: "fadeInUp 0.8s ease-out 0.2s both"
//     }}>
//       Discover our exclusive range of premium products
//     </p>
//   </div>

//   <div style={{
//     display: "grid",
//     gridTemplateColumns: screenSize.isMobile ? "1fr" : "1fr 1fr 1fr",
//     gap: screenSize.isMobile ? "25px" : "30px",
//     position: "relative"
//   }}>
//     {/* Animated background elements */}
//     <div style={{
//       position: "absolute",
//       top: "-100px",
//       right: "-100px",
//       width: "300px",
//       height: "300px",
//       borderRadius: "50%",
//       background: "radial-gradient(circle, rgba(42,85,178,0.05) 0%, transparent 70%)",
//       filter: "blur(20px)",
//       animation: "float 15s ease-in-out infinite alternate",
//       zIndex: 0
//     }}></div>
    
//     <div style={{
//       position: "absolute",
//       bottom: "-100px",
//       left: "-100px",
//       width: "400px",
//       height: "400px",
//       borderRadius: "50%",
//       background: "radial-gradient(circle, rgba(255,107,107,0.05) 0%, transparent 70%)",
//       filter: "blur(20px)",
//       animation: "float 18s ease-in-out infinite alternate-reverse",
//       zIndex: 0
//     }}></div>

//     {/* Watches Category */}
//     <div 
//       className="category-card"
//       style={{
//         position: "relative",
//         height: screenSize.isMobile ? "220px" : "300px",
//         borderRadius: "16px",
//         overflow: "hidden",
//         boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//         transition: "all 0.5s cubic-bezier(0.23, 1, 0.32, 1)",
//         cursor: "pointer",
//         animation: "scaleIn 0.6s ease-out",
//         transformStyle: "preserve-3d",
//         zIndex: 1
//       }} 
//       onClick={() => navigate("/watches")}
//       onMouseEnter={(e) => {
//         if (!screenSize.isMobile) {
//           e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
//           e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
//         }
//       }}
//       onMouseLeave={(e) => {
//         if (!screenSize.isMobile) {
//           e.currentTarget.style.transform = 'translateY(0) scale(1)';
//           e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
//         }
//       }}
//     >
//       <div style={{
//         position: "absolute",
//         inset: 0,
//         background: "linear-gradient(45deg, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
//         zIndex: 2,
//         opacity: 0,
//         transition: "opacity 0.4s ease",
//         pointerEvents: "none"
//       }} className="category-overlay"></div>
      
//       <img src={img1} alt="Luxury Watches" style={{
//         width: "100%",
//         height: "100%",
//         objectFit: "cover",
//         transition: "transform 0.8s cubic-bezier(0.23, 1, 0.32, 1)",
//       }} className="category-image" />
      
//       <div style={{
//         position: "absolute",
//         bottom: "0",
//         left: "0",
//         right: "0",
//         padding: "25px",
//         background: "linear-gradient(to top, rgba(0,0,0,0.9), transparent)",
//         color: colors.textLight,
//         zIndex: 3,
//         transform: "translateY(5px)",
//         opacity: 0,
//         transition: "all 0.5s ease"
//       }} className="category-content">
//         <h3 style={{
//           fontSize: screenSize.isMobile ? "1.3rem" : "1.6rem",
//           marginBottom: "12px",
//           fontWeight: "700",
//           letterSpacing: "0.5px"
//         }}>Watches</h3>
//         <p style={{
//           marginBottom: "20px",
//           fontSize: "0.95rem",
//           opacity: "0.9",
//           lineHeight: "1.5"
//         }}>Precision crafted timepieces for the discerning individual</p>
//         <button style={{
//           backgroundColor: "transparent",
//           color: colors.textLight,
//           border: `2px solid ${colors.textLight}`,
//           padding: "10px 24px",
//           borderRadius: "30px",
//           fontSize: "0.9rem",
//           fontWeight: "600",
//           cursor: "pointer",
//           transition: "all 0.3s ease",
//           letterSpacing: "0.5px",
//           position: "relative",
//           overflow: "hidden"
//         }}>
//           <span style={{
//             position: "relative",
//             zIndex: 2
//           }}>Explore Collection</span>
//           <span style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: colors.textLight,
//             transform: "translateX(-100%)",
//             transition: "transform 0.4s ease",
//             zIndex: 1
//           }} className="button-hover-bg"></span>
//         </button>
//       </div>
      
//       {/* Floating elements */}
//       <div style={{
//         position: "absolute",
//         top: "20px",
//         right: "20px",
//         width: "50px",
//         height: "50px",
//         borderRadius: "50%",
//         background: "rgba(255,255,255,0.2)",
//         animation: "pulse 2s infinite",
//         zIndex: 2
//       }}></div>
//     </div>

//     {/* Sunglasses Category */}
//     <div 
//       className="category-card"
//       style={{
//         position: "relative",
//         height: screenSize.isMobile ? "220px" : "300px",
//         borderRadius: "16px",
//         overflow: "hidden",
//         boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//         transition: "all 0.5s cubic-bezier(0.23, 1, 0.32, 1)",
//         cursor: "pointer",
//         animation: "scaleIn 0.6s ease-out 0.2s both",
//         transformStyle: "preserve-3d",
//         zIndex: 1
//       }} 
//       onClick={() => navigate("/sunglasses")}
//       onMouseEnter={(e) => {
//         if (!screenSize.isMobile) {
//           e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
//           e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
//         }
//       }}
//       onMouseLeave={(e) => {
//         if (!screenSize.isMobile) {
//           e.currentTarget.style.transform = 'translateY(0) scale(1)';
//           e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
//         }
//       }}
//     >
//       <div style={{
//         position: "absolute",
//         inset: 0,
//         background: "linear-gradient(45deg, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
//         zIndex: 2,
//         opacity: 0,
//         transition: "opacity 0.4s ease",
//         pointerEvents: "none"
//       }} className="category-overlay"></div>
      
//       <img src={img2} alt="Designer Sunglasses" style={{
//         width: "100%",
//         height: "100%",
//         objectFit: "cover",
//         transition: "transform 0.8s cubic-bezier(0.23, 1, 0.32, 1)",
//       }} className="category-image" />
      
//       <div style={{
//         position: "absolute",
//         bottom: "0",
//         left: "0",
//         right: "0",
//         padding: "25px",
//         background: "linear-gradient(to top, rgba(0,0,0,0.9), transparent)",
//         color: colors.textLight,
//         zIndex: 3,
//         transform: "translateY(5px)",
//         opacity: 0,
//         transition: "all 0.5s ease"
//       }} className="category-content">
//         <h3 style={{
//           fontSize: screenSize.isMobile ? "1.3rem" : "1.6rem",
//           marginBottom: "12px",
//           fontWeight: "700",
//           letterSpacing: "0.5px"
//         }}>Sunglasses</h3>
//         <p style={{
//           marginBottom: "20px",
//           fontSize: "0.95rem",
//           opacity: "0.9",
//           lineHeight: "1.5"
//         }}>Elegant eyewear that combines style with protection</p>
//         <button style={{
//           backgroundColor: "transparent",
//           color: colors.textLight,
//           border: `2px solid ${colors.textLight}`,
//           padding: "10px 24px",
//           borderRadius: "30px",
//           fontSize: "0.9rem",
//           fontWeight: "600",
//           cursor: "pointer",
//           transition: "all 0.3s ease",
//           letterSpacing: "0.5px",
//           position: "relative",
//           overflow: "hidden"
//         }}>
//           <span style={{
//             position: "relative",
//             zIndex: 2
//           }}>Explore Collection</span>
//           <span style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: colors.textLight,
//             transform: "translateX(-100%)",
//             transition: "transform 0.4s ease",
//             zIndex: 1
//           }} className="button-hover-bg"></span>
//         </button>
//       </div>
      
//       {/* Floating elements */}
//       <div style={{
//         position: "absolute",
//         top: "20px",
//         left: "20px",
//         width: "30px",
//         height: "30px",
//         borderRadius: "50%",
//         background: "rgba(255,255,255,0.2)",
//         animation: "pulse 2s infinite 1s",
//         zIndex: 2
//       }}></div>
//     </div>

//     {/* Accessories Category */}
//     <div 
//       className="category-card"
//       style={{
//         position: "relative",
//         height: screenSize.isMobile ? "220px" : "300px",
//         borderRadius: "16px",
//         overflow: "hidden",
//         boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//         transition: "all 0.5s cubic-bezier(0.23, 1, 0.32, 1)",
//         cursor: "pointer",
//         animation: "scaleIn 0.6s ease-out 0.4s both",
//         transformStyle: "preserve-3d",
//         zIndex: 1
//       }} 
//       onClick={() => navigate("/accessories")}
//       onMouseEnter={(e) => {
//         if (!screenSize.isMobile) {
//           e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
//           e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
//         }
//       }}
//       onMouseLeave={(e) => {
//         if (!screenSize.isMobile) {
//           e.currentTarget.style.transform = 'translateY(0) scale(1)';
//           e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
//         }
//       }}
//     >
//       <div style={{
//         position: "absolute",
//         inset: 0,
//         background: "linear-gradient(45deg, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
//         zIndex: 2,
//         opacity: 0,
//         transition: "opacity 0.4s ease",
//         pointerEvents: "none"
//       }} className="category-overlay"></div>
      
//       <img src={img3} alt="Elegant Accessories" style={{
//         width: "100%",
//         height: "100%",
//         objectFit: "cover",
//         transition: "transform 0.8s cubic-bezier(0.23, 1, 0.32, 1)",
//       }} className="category-image" />
      
//       <div style={{
//         position: "absolute",
//         bottom: "0",
//         left: "0",
//         right: "0",
//         padding: "25px",
//         background: "linear-gradient(to top, rgba(0,0,0,0.9), transparent)",
//         color: colors.textLight,
//         zIndex: 3,
//         transform: "translateY(5px)",
//         opacity: 0,
//         transition: "all 0.5s ease"
//       }} className="category-content">
//         <h3 style={{
//           fontSize: screenSize.isMobile ? "1.3rem" : "1.6rem",
//           marginBottom: "12px",
//           fontWeight: "700",
//           letterSpacing: "0.5px"
//         }}>Accessories</h3>
//         <p style={{
//           marginBottom: "20px",
//           fontSize: "0.95rem",
//           opacity: "0.9",
//           lineHeight: "1.5"
//         }}>Complement your style with our exquisite range of accessories</p>
//         <button style={{
//           backgroundColor: "transparent",
//           color: colors.textLight,
//           border: `2px solid ${colors.textLight}`,
//           padding: "10px 24px",
//           borderRadius: "30px",
//           fontSize: "0.9rem",
//           fontWeight: "600",
//           cursor: "pointer",
//           transition: "all 0.3s ease",
//           letterSpacing: "0.5px",
//           position: "relative",
//           overflow: "hidden"
//         }}>
//           <span style={{
//             position: "relative",
//             zIndex: 2
//           }}>Explore Collection</span>
//           <span style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: colors.textLight,
//             transform: "translateX(-100%)",
//             transition: "transform 0.4s ease",
//             zIndex: 1
//           }} className="button-hover-bg"></span>
//         </button>
//       </div>
      
//       {/* Floating elements */}
//       <div style={{
//         position: "absolute",
//         bottom: "20px",
//         right: "20px",
//         width: "40px",
//         height: "40px",
//         borderRadius: "50%",
//         background: "rgba(255,255,255,0.2)",
//         animation: "pulse 2s infinite 0.5s",
//         zIndex: 2
//       }}></div>
//     </div>
//   </div>

//   <style>
//     {`
//       /* Category card hover effects */
//       .category-card:hover .category-overlay {
//         opacity: 1 !important;
//       }
      
//       .category-card:hover .category-image {
//         transform: scale(1.1) !important;
//       }
      
//       .category-card:hover .category-content {
//         transform: translateY(0) !important;
//         opacity: 1 !important;
//       }
      
//       /* Button hover effect */
//       .category-card button:hover .button-hover-bg {
//         transform: translateX(0) !important;
//       }
      
//       .category-card button:hover {
//         color: ${colors.primary} !important;
//       }
      
//       /* Animations */
//       @keyframes fadeInUp {
//         from {
//           opacity: 0;
//           transform: translateY(30px);
//         }
//         to {
//           opacity: 1;
//           transform: translateY(0);
//         }
//       }
      
//       @keyframes scaleIn {
//         from {
//           opacity: 0;
//           transform: scale(0.9);
//         }
//         to {
//           opacity: 1;
//           transform: scale(1);
//         }
//       }
      
//       @keyframes lineExpand {
//         from {
//           width: 0;
//         }
//         to {
//           width: 60px;
//         }
//       }
      
//       @keyframes float {
//         0% {
//           transform: translateY(0) rotate(0deg);
//         }
//         100% {
//           transform: translateY(-20px) rotate(2deg);
//         }
//       }
      
//       @keyframes pulse {
//         0% {
//           transform: scale(1);
//           opacity: 0.7;
//         }
//         50% {
//           transform: scale(1.1);
//           opacity: 0.4;
//         }
//         100% {
//           transform: scale(1);
//           opacity: 0.7;
//         }
//       }
      
//       /* Mobile optimizations */
//       @media (max-width: 768px) {
//         .category-content {
//           transform: translateY(0) !important;
//           opacity: 1 !important;
//         }
        
//         .category-card {
//           animation: fadeInUp 0.6s ease-out !important;
//         }
        
//         .category-card:nth-child(2) {
//           animation-delay: 0.2s !important;
//         }
        
//         .category-card:nth-child(3) {
//           animation-delay: 0.4s !important;
//         }
//       }
//     `}
//   </style>
// </section>

//       {/* Featured Products - Stunning Design */}
//       <section style={{
//   maxWidth: screenSize.isLargeDesktop ? "1500px" : "1300px",
//   margin: "0 auto",
//   padding: screenSize.isMobile ? "20px 15px 40px" : "40px 20px 80px",
//   position: "relative",
//   overflow: "hidden",
//   background: "radial-gradient(ellipse at top, rgba(250,245,240,0.1) 0%, transparent 70%)"
// }}>
//   {/* Floating Decorative Elements */}
//   <div style={{
//     position: "absolute",
//     top: "10%",
//     right: "5%",
//     width: "300px",
//     height: "300px",
//     borderRadius: "50%",
//     background: "radial-gradient(circle, rgba(102,126,234,0.05) 0%, transparent 70%)",
//     filter: "blur(30px)",
//     animation: "float 15s ease-in-out infinite alternate",
//     zIndex: 0
//   }}></div>
  
//   <div style={{
//     position: "absolute",
//     bottom: "15%",
//     left: "5%",
//     width: "400px",
//     height: "400px",
//     borderRadius: "50%",
//     background: "radial-gradient(circle, rgba(193,154,107,0.04) 0%, transparent 70%)",
//     filter: "blur(30px)",
//     animation: "float 18s ease-in-out infinite alternate-reverse",
//     zIndex: 0
//   }}></div>

//   {/* Section Header - Enhanced */}
//   <div style={{
//     textAlign: "center",
//     marginBottom: screenSize.isMobile ? "40px" : "60px",
//     position: "relative"
//   }}>
//     <div style={{
//       position: "absolute",
//       top: "50%",
//       left: "50%",
//       transform: "translate(-50%, -50%)",
//       width: "120%",
//       height: "200px",
//       background: "linear-gradient(135deg, rgba(118,75,162,0.02) 0%, rgba(102,126,234,0.02) 100%)",
//       borderRadius: "20px",
//       filter: "blur(30px)",
//       zIndex: 0,
//       animation: "pulse 8s cubic-bezier(0.4, 0, 0.6, 1) infinite"
//     }}></div>
    
//     <div style={{
//       position: "absolute",
//       top: "50%",
//       left: "50%",
//       transform: "translate(-50%, -50%)",
//       width: "200px",
//       height: "200px",
//       background: "radial-gradient(circle, rgba(193, 154, 107, 0.05) 0%, transparent 70%)",
//       borderRadius: "50%",
//       zIndex: 0
//     }}></div>
    
//     <h2 style={{
//       fontSize: (() => {
//         if (screenSize.isMobile) return "2rem";
//         if (screenSize.isTablet) return "2.5rem";
//         if (screenSize.isLargeDesktop) return "3.5rem";
//         return "3rem";
//       })(),
//       fontWeight: "300",
//       color: "transparent",
//       marginBottom: "20px",
//       fontFamily: "'Playfair Display', serif",
//       position: "relative",
//       zIndex: 1,
//       background: "linear-gradient(135deg, #667eea 20%, #764ba2 60%, #c19a6b 90%)",
//       WebkitBackgroundClip: "text",
//       backgroundClip: "text",
//       textShadow: "0 2px 10px rgba(118,75,162,0.2)",
//       animation: "titleSlideIn 0.8s ease-out, textGlow 3s ease-in-out infinite alternate"
//     }}>
//       Featured Pieces
//     </h2>
    
//     <div style={{
//       width: "80px",
//       height: "4px",
//       background: "linear-gradient(135deg, #667eea, #764ba2)",
//       margin: "0 auto 20px",
//       borderRadius: "2px",
//       animation: "lineExpand 0.8s ease-out 0.3s both, colorShift 6s linear infinite",
//       boxShadow: "0 2px 10px rgba(102,126,234,0.3)"
//     }}></div>
    
//     <p style={{
//       color: colors.textDark,
//       fontSize: screenSize.isMobile ? "1rem" : "1.2rem",
//       maxWidth: "600px",
//       margin: "0 auto",
//       lineHeight: "1.6",
//       opacity: "0.8",
//       animation: "fadeInUp 0.8s ease-out 0.5s both",
//       position: "relative",
//       zIndex: 1
//     }}>
//       Handpicked luxury items that define elegance and sophistication
//     </p>
//   </div>

//   {/* Product Grid - Enhanced with 3D Tilt Effect */}
//  {/* Products Grid - 2 Column Mobile Layout */}
// <div style={{
//   display: "grid",
//   gridTemplateColumns: screenSize.isMobile ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(280px, 1fr))",
//   gap: screenSize.isMobile ? "12px" : "24px",
//   padding: screenSize.isMobile ? "0 10px" : "0 20px",
//   maxWidth: "100%",
//   margin: "0 auto"
// }}>
//   {featuredProducts.map((product, index) => (
//     <ProductCard
//       key={product.id}
//       product={product}
//       index={index}
//       section="featured"
//     />
//   ))}
// </div>


//   {/* View All Button - Enhanced with Ripple Effect */}
//   <div style={{ textAlign: "center", position: "relative", zIndex: 1 }}>
//     <button 
//       onClick={(e) => {
//         navigate("/products?sort=featured");
//         // Ripple effect
//         const button = e.currentTarget;
//         const ripple = document.createElement("span");
//         ripple.style.position = "absolute";
//         ripple.style.borderRadius = "50%";
//         ripple.style.transform = "scale(0)";
//         ripple.style.animation = "ripple 600ms linear";
//         ripple.style.backgroundColor = "rgba(255, 255, 255, 0.4)";
//         ripple.style.pointerEvents = "none";
        
//         const rect = button.getBoundingClientRect();
//         const size = Math.max(rect.width, rect.height);
//         const x = e.clientX - rect.left - size/2;
//         const y = e.clientY - rect.top - size/2;
        
//         ripple.style.width = ripple.style.height = `${size}px`;
//         ripple.style.left = `${x}px`;
//         ripple.style.top = `${y}px`;
        
//         button.appendChild(ripple);
//         setTimeout(() => ripple.remove(), 600);
//       }}
//       style={{
//         background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//         color: "white",
//         border: "none",
//         padding: screenSize.isMobile ? "15px 30px" : "18px 40px",
//         borderRadius: "50px",
//         fontSize: screenSize.isMobile ? "1rem" : "1.1rem",
//         fontWeight: "600",
//         cursor: "pointer",
//         transition: "all 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
//         boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
//         letterSpacing: "0.5px",
//         textTransform: "uppercase",
//         animation: "buttonFloat 3s ease-in-out infinite",
//         position: "relative",
//         overflow: "hidden"
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = "translateY(-3px) scale(1.05)";
//         e.currentTarget.style.boxShadow = "0 15px 40px rgba(102, 126, 234, 0.4)";
//         e.currentTarget.querySelector('.button-bg').style.opacity = "1";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = "translateY(0) scale(1)";
//         e.currentTarget.style.boxShadow = "0 10px 30px rgba(102, 126, 234, 0.3)";
//         e.currentTarget.querySelector('.button-bg').style.opacity = "0";
//       }}
//     >
//       <span className="button-bg" style={{
//         position: "absolute",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         background: "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 100%)",
//         zIndex: -1,
//         opacity: 0,
//         transition: "opacity 0.4s ease"
//       }}></span>
//       View All Featured Products
//       <span style={{
//         position: "absolute",
//         top: "0",
//         left: "-100%",
//         width: "100%",
//         height: "100%",
//         background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
//         transition: "left 0.6s ease"
//       }}></span>
//     </button>
//   </div>

//   {/* CSS Animations */}
//   <style jsx>{`
//     @keyframes float {
//       0% { transform: translateY(0) rotate(0deg); }
//       100% { transform: translateY(-20px) rotate(2deg); }
//     }
    
//     @keyframes textGlow {
//       0% { text-shadow: 0 2px 10px rgba(118,75,162,0.2); }
//       100% { text-shadow: 0 4px 20px rgba(118,75,162,0.4); }
//     }
    
//     @keyframes lineExpand {
//       0% { transform: scaleX(0); opacity: 0; }
//       100% { transform: scaleX(1); opacity: 1; }
//     }
    
//     @keyframes colorShift {
//       0% { background-position: 0% 50%; }
//       50% { background-position: 100% 50%; }
//       100% { background-position: 0% 50%; }
//     }
    
//     @keyframes cardAppear {
//       0% { opacity: 0; transform: translateY(30px); }
//       100% { opacity: 1; transform: translateY(0); }
//     }
    
//     @keyframes buttonFloat {
//       0%, 100% { transform: translateY(0); }
//       50% { transform: translateY(-5px); }
//     }
    
//     @keyframes pulse {
//       0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(0.95); }
//       50% { opacity: 0.2; transform: translate(-50%, -50%) scale(1.05); }
//     }
    
//     @keyframes ripple {
//       to {
//         transform: "scale(4)";
//         opacity: 0;
//       }
//     }
    
//     @keyframes titleSlideIn {
//       from { 
//         opacity: 0;
//         transform: translateY(20px);
//       }
//       to { 
//         opacity: 1;
//         transform: translateY(0);
//       }
//     }
    
//     @keyframes fadeInUp {
//       from { 
//         opacity: 0;
//         transform: translateY(20px);
//       }
//       to { 
//         opacity: 0.8;
//         transform: translateY(0);
//       }
//     }
//   `}</style>
// </section>

//       {/* New Arrivals - Stunning Design */}
//       <section style={{
//         maxWidth: screenSize.isLargeDesktop ? "1500px" : "1300px",
//         margin: "0 auto",
//         padding: screenSize.isMobile ? "20px 15px 40px" : "40px 20px 80px",
//         position: "relative",
//         background: "linear-gradient(135deg, rgba(102, 126, 234, 0.02) 0%, rgba(118, 75, 162, 0.02) 100%)",
//         borderRadius: "40px"
//       }}>
//         {/* Section Header */}
//         <div style={{
//           textAlign: "center",
//           marginBottom: screenSize.isMobile ? "40px" : "60px",
//           position: "relative"
//         }}>
//           <h2 style={{
//             fontSize: (() => {
//               if (screenSize.isMobile) return "2rem";
//               if (screenSize.isTablet) return "2.5rem";
//               if (screenSize.isLargeDesktop) return "3.5rem";
//               return "3rem";
//             })(),
//             fontWeight: "300",
//             color: colors.primary,
//             marginBottom: "20px",
//             fontFamily: "'Playfair Display', serif",
//             background: "linear-gradient(135deg, #667eea, #764ba2)",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             animation: "titleSlideIn 0.8s ease-out"
//           }}>
//             New Arrivals
//           </h2>
          
//           <div style={{
//             width: "80px",
//             height: "4px",
//             background: "linear-gradient(135deg, #4ecdc4, #44a08d)",
//             margin: "0 auto 20px",
//             borderRadius: "2px",
//             animation: "lineExpand 0.8s ease-out 0.3s both"
//           }}></div>
          
//           <p style={{
//             color: colors.textDark,
//             fontSize: screenSize.isMobile ? "1rem" : "1.2rem",
//             maxWidth: "600px",
//             margin: "0 auto",
//             lineHeight: "1.6",
//             opacity: "0.8",
//             animation: "fadeInUp 0.8s ease-out 0.5s both"
//           }}>
//             Fresh additions to our luxury collection
//           </p>
//         </div>

//         {/* Products Grid */}
//        {/* Products Grid - 2 Column Mobile Layout */}
// <div style={{
//   display: "grid",
//   gridTemplateColumns: screenSize.isMobile ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(280px, 1fr))",
//   gap: screenSize.isMobile ? "12px" : "24px",
//   padding: screenSize.isMobile ? "0 10px" : "0 20px",
//   maxWidth: "100%",
//   margin: "0 auto"
// }}>
//   {featuredProducts.map((product, index) => (
//     <ProductCard
//       key={product.id}
//       product={product}
//       index={index}
//       section="featured"
//     />
//   ))}
// </div>


//         {/* View All Button */}
//         <div style={{ textAlign: "center" }}>
//           <button 
//             onClick={() => navigate("/products?sort=newest")}
//             style={{
//               background: "linear-gradient(135deg, #4ecdc4 0%, #44a08d 100%)",
//               color: "white",
//               border: "none",
//               padding: screenSize.isMobile ? "15px 30px" : "18px 40px",
//               borderRadius: "50px",
//               fontSize: screenSize.isMobile ? "1rem" : "1.1rem",
//               fontWeight: "600",
//               cursor: "pointer",
//               transition: "all 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
//               boxShadow: "0 10px 30px rgba(78, 205, 196, 0.3)",
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//               animation: "buttonFloat 3s ease-in-out infinite 1.5s",
//               position: "relative",
//               overflow: "hidden"
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = "translateY(-3px) scale(1.05)";
//               e.currentTarget.style.boxShadow = "0 15px 40px rgba(78, 205, 196, 0.4)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = "translateY(0) scale(1)";
//               e.currentTarget.style.boxShadow = "0 10px 30px rgba(78, 205, 196, 0.3)";
//             }}
//           >
//             View All New Arrivals
//           </button>
//         </div>
//       </section>

//       <Footer />

//       <style>
//         {`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
          
//           @keyframes fadeInUp {
//             from {
//               opacity: 0;
//               transform: translateY(30px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
          
//           @keyframes scaleIn {
//             from {
//               transform: scale(0.8);
//               opacity: 0;
//             }
//             to {
//               transform: scale(1);
//               opacity: 1;
//             }
//           }
          
//           @keyframes slideInFromTop {
//             from {
//               opacity: 0;
//               transform: translateY(-20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
          
//           @keyframes scaleX {
//             from {
//               transform: scaleX(0);
//             }
//             to {
//               transform: scaleX(0.7);
//             }
//           }
          
//           @keyframes cardSlideUp {
//             from {
//               opacity: 0;
//               transform: translateY(60px) scale(0.8);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0) scale(1);
//             }
//           }
          
//           @keyframes titleSlideIn {
//             from {
//               opacity: 0;
//               transform: translateY(-30px);
//               letter-spacing: 10px;
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//               letter-spacing: normal;
//             }
//           }
          
//           @keyframes lineExpand {
//             from {
//               width: 0;
//               opacity: 0;
//             }
//             to {
//               width: 80px;
//               opacity: 1;
//             }
//           }
          
//           @keyframes buttonFloat {
//             0%, 100% {
//               transform: translateY(0);
//             }
//             50% {
//               transform: translateY(-3px);
//             }
//           }
          
//           @keyframes pulse {
//             0% {
//               transform: scale(1);
//             }
//             50% {
//               transform: scale(1.05);
//             }
//             100% {
//               transform: scale(1);
//             }
//           }
          
//           @keyframes shimmer {
//             0% {
//               transform: translateX(-100%);
//             }
//             100% {
//               transform: translateX(100%);
//             }
//           }

//           /* Responsive Media Queries */
//           @media (max-width: 480px) {
//             .product-card {
//               max-width: 180px !important;
//             }
//             .product-card h3 {
//               font-size: 0.9rem !important;
//             }
//             .product-card .price {
//               font-size: 1rem !important;
//             }
//           }

//           @media (min-width: 481px) and (max-width: 767px) {
//             .product-card {
//               max-width: 200px !important;
//             }
//           }

//           @media (min-width: 768px) and (max-width: 1023px) {
//             .product-card {
//               max-width: 240px !important;
//             }
//           }

//           @media (min-width: 1024px) {
//             .product-card {
//               max-width: 280px !important;
//             }
//           }

//           /* Touch optimizations */
//           @media (hover: none) and (pointer: coarse) {
//             .product-card:hover {
//               transform: none !important;
//             }
//             .product-card .overlay-icons {
//               opacity: 1 !important;
//               transform: translateX(0) !important;
//             }
//             .add-to-cart-btn {
//               opacity: 1 !important;
//               transform: translateX(-50%) translateY(0) !important;
//             }
//           }

//           /* High-DPI display optimizations */
//           @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
//             .product-card img {
//               image-rendering: -webkit-optimize-contrast;
//               image-rendering: optimize-contrast;
//             }
//           }

//           /* Reduced motion preferences */
//           @media (prefers-reduced-motion: reduce) {
//             * {
//               animation-duration: 0.01ms !important;
//               animation-iteration-count: 1 !important;
//               transition-duration: 0.01ms !important;
//             }
//           }

//           /* Dark mode support */
//           @media (prefers-color-scheme: dark) {
//             .product-card {
//               background: linear-gradient(145deg, #2a2a2a, #1a1a1a) !important;
//               color: white !important;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default HomePage;


import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart, FaSearch, FaHeart, FaStar, FaRegStar, FaEye } from "react-icons/fa";
import { db, ref, auth } from "../firebase";
import { onValue } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";
import Navbar from "./Navbar";
import img1 from "../assets/img1.jpg";
import img2 from "../assets/img2.jpg";
import img3 from "../assets/img3.jpg";
import ProductSlider from "./Slider";
import Footer from "./Footer";

const HomePage = () => {
  const navigate = useNavigate();
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cartCount, setCartCount] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);
  const [screenSize, setScreenSize] = useState({
    isMobile: window.innerWidth < 768,
    isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
    isDesktop: window.innerWidth >= 1024,
    isLargeDesktop: window.innerWidth >= 1440,
    width: window.innerWidth,
    height: window.innerHeight
  });

  // Use ref to debounce resize events
  const resizeTimerRef = useRef(null);

  // Responsive breakpoints handler with debouncing - FIXED
  useEffect(() => {
    const handleResize = () => {
      // Clear the previous timer
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
      }

      // Set a new timer to update state only after resize stops
      resizeTimerRef.current = setTimeout(() => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        
        // Only update if dimensions actually changed significantly
        setScreenSize(prev => {
          const widthChanged = Math.abs(prev.width - width) > 10;
          const heightChanged = Math.abs(prev.height - height) > 10;
          
          if (!widthChanged && !heightChanged) {
            return prev; // Don't update if change is minimal
          }
          
          return {
            isMobile: width < 768,
            isTablet: width >= 768 && width < 1024,
            isDesktop: width >= 1024,
            isLargeDesktop: width >= 1440,
            width,
            height
          };
        });
      }, 150); // Wait 150ms after resize stops
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
      }
    };
  }, []);

  const colors = {
    primary: "#1a1a1a",
    secondary: "#f5f5f5",
    accent: "#c19a6b",
    textDark: "#333333",
    textLight: "#ffffff",
    background: "#f9f7f5",
    highlight: "rgba(193, 154, 107, 0.2)",
    border: "rgba(0, 0, 0, 0.1)",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    glass: "rgba(255, 255, 255, 0.25)",
    shadow: "rgba(0, 0, 0, 0.1)",
    logoDarkGray: "#272424",
    logoBrightRed: "#ed3237",
    logoCharcoal: "#373c3c",
    logoDeepRed: "#8f2d30",
    logoMediumGray: "#646262",
    logoVeryDarkGray: "#201d1d",
    logoPurple: "#6a0dad"
  };

  // Check authentication state
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userData = {
          uid: user.uid,
          displayName: user.displayName || user.email.split("@")[0],
          email: user.email,
          photoURL: user.photoURL || "/default-user.png",
        };
        setCurrentUser(userData);
        localStorage.setItem("user", JSON.stringify(userData));
      } else {
        setCurrentUser(null);
        localStorage.removeItem("user");
      }
    });

    // Load products
    const productsRef = ref(db, "Watch/admin/products");
    const unsubscribeProducts = onValue(productsRef, (snapshot) => {
      const productsData = snapshot.val();
      if (productsData) {
        const productsList = Object.entries(productsData).map(([id, data]) => ({
          id,
          ...data,
          price: parseFloat(data.price),
          discount: data.discount || 0,
        }));

        setFeaturedProducts(productsList.filter((p) => p.featured).slice(0, 6));
        setNewArrivals(
          [...productsList]
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .slice(0, 6)
        );
      }
      setLoading(false);
    });

    // Load cart
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartCount(cart.reduce((total, item) => total + item.quantity, 0));

    return () => {
      unsubscribeAuth();
      unsubscribeProducts();
    };
  }, []);

  const renderRating = (rating) => {
    return Array(5)
      .fill()
      .map((_, i) =>
        i < Math.floor(rating || 4) ? (
          <FaStar 
            key={i} 
            style={{ 
              color: colors.accent,
              fontSize: "0.9rem"
            }} 
          />
        ) : (
          <FaRegStar 
            key={i} 
            style={{ 
              color: colors.accent,
              fontSize: "0.9rem"
            }} 
          />
        )
      );
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`, {
      state: {
        user: currentUser,
      },
    });
  };

  const addToCart = (product, e) => {
    e.stopPropagation();
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingItem = cart.find((item) => item.id === product.id);

    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      cart.push({
        id: product.id,
        name: product.name,
        price: product.price * (1 - (product.discount || 0) / 100),
        image: product.images?.[0] || "/placeholder-product.jpg",
        quantity: 1,
      });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    setCartCount(cart.reduce((total, item) => total + item.quantity, 0));
  };

  const ProductCard = ({ product, index, section = "featured" }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    
    return (
      <div 
        style={{
          position: "relative",
          width: "100%",
          background: "linear-gradient(145deg, #ffffff, #f8f8f8)",
          borderRadius: screenSize.isMobile ? "12px" : "20px",
          overflow: "hidden",
          boxShadow: isHovered 
            ? "0 15px 30px rgba(0,0,0,0.12)" 
            : "0 8px 20px rgba(0,0,0,0.08)",
          // transition: "all 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
          cursor: "pointer",
          // animation: `cardSlideUp 0.6s ease-out ${index * 0.1}s both`,
          // transform: isHovered && !screenSize.isMobile
          //   ? "translateY(-8px)" 
          //   : "translateY(0)",
          // border: "1px solid rgba(0,0,0,0.05)"
        }}
        onClick={() => handleProductClick(product.id)}
        onMouseEnter={() => !screenSize.isMobile && setIsHovered(true)}
        onMouseLeave={() => !screenSize.isMobile && setIsHovered(false)}
      >
        {/* Image Container */}
        <div style={{
          position: "relative",
          paddingBottom: "100%",
          overflow: "hidden",
          background: "#f0f0f0"
        }}>
          {!imageLoaded && (
            <div style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "30px",
              height: "30px",
              border: `3px solid ${colors.accent}`,
              borderTopColor: "transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite"
            }}></div>
          )}
          
          <img 
            src={product.images?.[0] || "/placeholder-product.jpg"} 
            alt={product.name}
            onLoad={() => setImageLoaded(true)}
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.6s ease",
              transform: isHovered ? "scale(1.08)" : "scale(1)",
              opacity: imageLoaded ? 1 : 0
            }} 
          />
          
          {/* Discount Badge */}
          {product.discount > 0 && (
            <div style={{
              position: "absolute",
              top: "10px",
              left: "10px",
              background: "linear-gradient(135deg, #ff6b6b, #ee5a24)",
              color: "white",
              padding: screenSize.isMobile ? "4px 8px" : "6px 12px",
              borderRadius: "12px",
              fontSize: screenSize.isMobile ? "0.7rem" : "0.75rem",
              fontWeight: "700",
              boxShadow: "0 4px 12px rgba(238, 90, 36, 0.3)",
              zIndex: 2
            }}>
              -{product.discount}%
            </div>
          )}
          
          {/* Wishlist Icon */}
          <button
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "rgba(255, 255, 255, 0.9)",
              border: "none",
              borderRadius: "50%",
              width: screenSize.isMobile ? "32px" : "36px",
              height: screenSize.isMobile ? "32px" : "36px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              zIndex: 2
            }}
          >
            <FaHeart style={{ 
              color: colors.accent, 
              fontSize: screenSize.isMobile ? "14px" : "16px" 
            }} />
          </button>
        </div>

        {/* Content */}
        <div style={{
          padding: screenSize.isMobile ? "12px" : "16px",
          background: "#fff"
        }}>
          {/* Product Name */}
          <h3 style={{
            fontSize: screenSize.isMobile ? "0.85rem" : "1rem",
            fontWeight: "600",
            color: colors.primary,
            marginBottom: "6px",
            lineHeight: "1.3",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            minHeight: screenSize.isMobile ? "2.2em" : "2.6em"
          }}>
            {product.name}
          </h3>

          {/* Brand */}
          <p style={{
            color: colors.textDark,
            fontSize: screenSize.isMobile ? "0.7rem" : "0.8rem",
            marginBottom: "8px",
            opacity: "0.6",
            fontWeight: "500",
            textTransform: "uppercase",
            letterSpacing: "0.3px"
          }}>
            {product.brand}
          </p>

          {/* Rating */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "3px",
            marginBottom: "10px"
          }}>
            {renderRating(product.rating)}
            <span style={{
              fontSize: screenSize.isMobile ? "0.7rem" : "0.75rem",
              color: colors.textDark,
              marginLeft: "6px",
              opacity: "0.6"
            }}>
              ({Math.floor(Math.random() * 50) + 10})
            </span>
          </div>

          {/* Price */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "6px"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}>
              <span style={{
                fontSize: screenSize.isMobile ? "1rem" : "1.1rem",
                fontWeight: "700",
                color: colors.primary,
                background: "linear-gradient(135deg, #667eea, #764ba2)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent"
              }}>
                ₹{(product.price * (1 - product.discount / 100)).toFixed(0)}
              </span>
              
              {product.discount > 0 && (
                <span style={{
                  fontSize: screenSize.isMobile ? "0.8rem" : "0.85rem",
                  color: "#999",
                  textDecoration: "line-through",
                  opacity: "0.6"
                }}>
                  ₹{product.price.toFixed(0)}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: colors.background,
        flexDirection: "column"
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          color: colors.primary,
          fontSize: "1.2rem",
          fontFamily: "'Playfair Display', serif"
        }}>
          <div style={{
            width: "40px",
            height: "40px",
            border: `4px solid ${colors.accent}`,
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 1s linear infinite"
          }}></div>
          Loading Luxury Collection...
        </div>
      </div>
    );
  }

  return (
    <div style={{
      backgroundColor: colors.background,
      minHeight: "100vh",
      fontFamily: "'Montserrat', sans-serif"
    }}>
      <Navbar currentUser={currentUser} cartCount={cartCount} />
      
      {currentUser && (
        <div style={{
          backgroundColor: colors.accent,
          color: colors.textLight,
          padding: screenSize.isMobile ? "10px 15px" : "8px 0",
          textAlign: "center",
          fontWeight: "500",
          fontSize: screenSize.isMobile ? "0.8rem" : "0.9rem",
          letterSpacing: screenSize.isMobile ? "0.5px" : "1px",
          fontFamily: "'Playfair Display', serif",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          animation: "slideInFromTop 0.5s ease-out"
        }}>
          Welcome back, {currentUser.displayName}!
        </div>
      )}

      <ProductSlider />

      {/* Explore Collections Section */}
      <section style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: screenSize.isMobile ? "40px 15px" : "60px 20px",
        overflow: "hidden"
      }}>
        <div style={{
          textAlign: "center",
          marginBottom: screenSize.isMobile ? "30px" : "50px"
        }}>
          <h2 style={{
            fontSize: screenSize.isMobile ? "1.8rem" : "2.5rem",
            fontWeight: "800",
            color: colors.textDark,
            marginBottom: "15px",
            position: "relative",
            display: "inline-block",
            animation: "fadeInUp 0.8s ease-out"
          }}>
            Explore Collections
            <span style={{
              position: "absolute",
              bottom: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "60px",
              height: "4px",
              background: colors.gradient,
              borderRadius: "2px",
              animation: "lineExpand 0.8s ease-out 0.3s both"
            }}></span>
          </h2>
          <p style={{
            color: colors.textDark,
            fontSize: "1.1rem",
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: "1.6",
            animation: "fadeInUp 0.8s ease-out 0.2s both",
            opacity: "0.7"
          }}>
            Discover our exclusive range of premium products
          </p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: screenSize.isMobile ? "1fr" : "1fr 1fr 1fr",
          gap: screenSize.isMobile ? "25px" : "30px",
          position: "relative"
        }}>
          {/* Watches Category */}
          <div 
            className="category-card"
            style={{
              position: "relative",
              height: screenSize.isMobile ? "220px" : "300px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              transition: "all 0.5s cubic-bezier(0.23, 1, 0.32, 1)",
              cursor: "pointer",
              animation: "scaleIn 0.6s ease-out",
              transformStyle: "preserve-3d",
              zIndex: 1
            }} 
            onClick={() => navigate("/watches")}
            onMouseEnter={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
              }
            }}
            onMouseLeave={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
              }
            }}
          >
            <div style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(45deg, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
              zIndex: 2,
              opacity: 0,
              transition: "opacity 0.4s ease",
              pointerEvents: "none"
            }} className="category-overlay"></div>
            
            <img src={img1} alt="Luxury Watches" style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.8s cubic-bezier(0.23, 1, 0.32, 1)",
            }} className="category-image" />
            
            <div style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              right: "0",
              padding: "25px",
              background: "linear-gradient(to top, rgba(0,0,0,0.9), transparent)",
              color: colors.textLight,
              zIndex: 3,
              transform: screenSize.isMobile ? "translateY(0)" : "translateY(5px)",
              opacity: screenSize.isMobile ? 1 : 0,
              transition: "all 0.5s ease"
            }} className="category-content">
              <h3 style={{
                fontSize: screenSize.isMobile ? "1.3rem" : "1.6rem",
                marginBottom: "12px",
                fontWeight: "700",
                letterSpacing: "0.5px"
              }}>Watches</h3>
              <p style={{
                marginBottom: "20px",
                fontSize: "0.95rem",
                opacity: "0.9",
                lineHeight: "1.5"
              }}>Precision crafted timepieces for the discerning individual</p>
              <button style={{
                backgroundColor: "transparent",
                color: colors.textLight,
                border: `2px solid ${colors.textLight}`,
                padding: "10px 24px",
                borderRadius: "30px",
                fontSize: "0.9rem",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
                letterSpacing: "0.5px",
                position: "relative",
                overflow: "hidden"
              }}>
                <span style={{
                  position: "relative",
                  zIndex: 2
                }}>Explore Collection</span>
              </button>
            </div>
            
            <div style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
              animation: "pulse 2s infinite",
              zIndex: 2
            }}></div>
          </div>

          {/* Sunglasses Category */}
          <div 
            className="category-card"
            style={{
              position: "relative",
              height: screenSize.isMobile ? "220px" : "300px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              transition: "all 0.5s cubic-bezier(0.23, 1, 0.32, 1)",
              cursor: "pointer",
              animation: "scaleIn 0.6s ease-out 0.2s both",
              transformStyle: "preserve-3d",
              zIndex: 1
            }} 
            onClick={() => navigate("/sunglasses")}
            onMouseEnter={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
              }
            }}
            onMouseLeave={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
              }
            }}
          >
            <div style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(45deg, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
              zIndex: 2,
              opacity: 0,
              transition: "opacity 0.4s ease",
              pointerEvents: "none"
            }} className="category-overlay"></div>
            
            <img src={img2} alt="Designer Sunglasses" style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.8s cubic-bezier(0.23, 1, 0.32, 1)",
            }} className="category-image" />
            
            <div style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              right: "0",
              padding: "25px",
              background: "linear-gradient(to top, rgba(0,0,0,0.9), transparent)",
              color: colors.textLight,
              zIndex: 3,
              transform: screenSize.isMobile ? "translateY(0)" : "translateY(5px)",
              opacity: screenSize.isMobile ? 1 : 0,
              transition: "all 0.5s ease"
            }} className="category-content">
              <h3 style={{
                fontSize: screenSize.isMobile ? "1.3rem" : "1.6rem",
                marginBottom: "12px",
                fontWeight: "700",
                letterSpacing: "0.5px"
              }}>Sunglasses</h3>
              <p style={{
                marginBottom: "20px",
                fontSize: "0.95rem",
                opacity: "0.9",
                lineHeight: "1.5"
              }}>Elegant eyewear that combines style with protection</p>
              <button style={{
                backgroundColor: "transparent",
                color: colors.textLight,
                border: `2px solid ${colors.textLight}`,
                padding: "10px 24px",
                borderRadius: "30px",
                fontSize: "0.9rem",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
                letterSpacing: "0.5px",
                position: "relative",
                overflow: "hidden"
              }}>
                <span style={{
                  position: "relative",
                  zIndex: 2
                }}>Explore Collection</span>
              </button>
            </div>
            
            <div style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
              animation: "pulse 2s infinite 1s",
              zIndex: 2
            }}></div>
          </div>

          {/* Accessories Category */}
          <div 
            className="category-card"
            style={{
              position: "relative",
              height: screenSize.isMobile ? "220px" : "300px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              transition: "all 0.5s cubic-bezier(0.23, 1, 0.32, 1)",
              cursor: "pointer",
              animation: "scaleIn 0.6s ease-out 0.4s both",
              transformStyle: "preserve-3d",
              zIndex: 1
            }} 
            onClick={() => navigate("/accessories")}
            onMouseEnter={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
              }
            }}
            onMouseLeave={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
              }
            }}
          >
            <div style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(45deg, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
              zIndex: 2,
              opacity: 0,
              transition: "opacity 0.4s ease",
              pointerEvents: "none"
            }} className="category-overlay"></div>
            
            <img src={img3} alt="Elegant Accessories" style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.8s cubic-bezier(0.23, 1, 0.32, 1)",
            }} className="category-image" />
            
            <div style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              right: "0",
              padding: "25px",
              background: "linear-gradient(to top, rgba(0,0,0,0.9), transparent)",
              color: colors.textLight,
              zIndex: 3,
              transform: screenSize.isMobile ? "translateY(0)" : "translateY(5px)",
              opacity: screenSize.isMobile ? 1 : 0,
              transition: "all 0.5s ease"
            }} className="category-content">
              <h3 style={{
                fontSize: screenSize.isMobile ? "1.3rem" : "1.6rem",
                marginBottom: "12px",
                fontWeight: "700",
                letterSpacing: "0.5px"
              }}>Accessories</h3>
              <p style={{
                marginBottom: "20px",
                fontSize: "0.95rem",
                opacity: "0.9",
                lineHeight: "1.5"
              }}>Complement your style with our exquisite range of accessories</p>
              <button style={{
                backgroundColor: "transparent",
                color: colors.textLight,
                border: `2px solid ${colors.textLight}`,
                padding: "10px 24px",
                borderRadius: "30px",
                fontSize: "0.9rem",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
                letterSpacing: "0.5px",
                position: "relative",
                overflow: "hidden"
              }}>
                <span style={{
                  position: "relative",
                  zIndex: 2
                }}>Explore Collection</span>
              </button>
            </div>
            
            <div style={{
              position: "absolute",
              bottom: "20px",
              right: "20px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
              animation: "pulse 2s infinite 0.5s",
              zIndex: 2
            }}></div>
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <section style={{
        maxWidth: screenSize.isLargeDesktop ? "1500px" : "1300px",
        margin: "0 auto",
        padding: screenSize.isMobile ? "20px 15px 40px" : "40px 20px 80px",
        position: "relative",
        overflow: "hidden"
      }}>
        <div style={{
          textAlign: "center",
          marginBottom: screenSize.isMobile ? "40px" : "60px",
          position: "relative"
        }}>
          <h2 style={{
            fontSize: screenSize.isMobile ? "2rem" : "3rem",
            fontWeight: "300",
            color: "transparent",
            marginBottom: "20px",
            fontFamily: "'Playfair Display', serif",
            position: "relative",
            zIndex: 1,
            background: "linear-gradient(135deg, #667eea 20%, #764ba2 60%, #c19a6b 90%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            animation: "titleSlideIn 0.8s ease-out"
          }}>
            Featured Pieces
          </h2>
          
          <div style={{
            width: "80px",
            height: "4px",
            background: "linear-gradient(135deg, #667eea, #764ba2)",
            margin: "0 auto 20px",
            borderRadius: "2px",
            animation: "lineExpand 0.8s ease-out 0.3s both"
          }}></div>
          
          <p style={{
            color: colors.textDark,
            fontSize: screenSize.isMobile ? "1rem" : "1.2rem",
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: "1.6",
            opacity: "0.8",
            animation: "fadeInUp 0.8s ease-out 0.5s both",
            position: "relative",
            zIndex: 1
          }}>
            Handpicked luxury items that define elegance and sophistication
          </p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: screenSize.isMobile ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(280px, 1fr))",
          gap: screenSize.isMobile ? "12px" : "24px",
          padding: screenSize.isMobile ? "0 10px" : "0 20px",
          maxWidth: "100%",
          margin: "0 auto 40px"
        }}>
          {featuredProducts.map((product, index) => (
            <ProductCard
              key={product.id}
              product={product}
              index={index}
              section="featured"
            />
          ))}
        </div>

        <div style={{ textAlign: "center" }}>
          <button 
            onClick={() => navigate("/products?sort=featured")}
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              border: "none",
              padding: screenSize.isMobile ? "15px 30px" : "18px 40px",
              borderRadius: "50px",
              fontSize: screenSize.isMobile ? "1rem" : "1.1rem",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
              boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              position: "relative",
              overflow: "hidden"
            }}
            onMouseEnter={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = "translateY(-3px) scale(1.05)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(102, 126, 234, 0.4)";
              }
            }}
            onMouseLeave={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = "translateY(0) scale(1)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(102, 126, 234, 0.3)";
              }
            }}
          >
            View All Featured Products
          </button>
        </div>
      </section>

      {/* New Arrivals Section */}
      <section style={{
        maxWidth: screenSize.isLargeDesktop ? "1500px" : "1300px",
        margin: "0 auto",
        padding: screenSize.isMobile ? "20px 15px 40px" : "40px 20px 80px",
        position: "relative",
        background: "linear-gradient(135deg, rgba(102, 126, 234, 0.02) 0%, rgba(118, 75, 162, 0.02) 100%)",
        borderRadius: "40px"
      }}>
        <div style={{
          textAlign: "center",
          marginBottom: screenSize.isMobile ? "40px" : "60px",
          position: "relative"
        }}>
          <h2 style={{
            fontSize: screenSize.isMobile ? "2rem" : "3rem",
            fontWeight: "300",
            color: colors.primary,
            marginBottom: "20px",
            fontFamily: "'Playfair Display', serif",
            background: "linear-gradient(135deg, #667eea, #764ba2)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            animation: "titleSlideIn 0.8s ease-out"
          }}>
            New Arrivals
          </h2>
          
          <div style={{
            width: "80px",
            height: "4px",
            background: "linear-gradient(135deg, #4ecdc4, #44a08d)",
            margin: "0 auto 20px",
            borderRadius: "2px",
            animation: "lineExpand 0.8s ease-out 0.3s both"
          }}></div>
          
          <p style={{
            color: colors.textDark,
            fontSize: screenSize.isMobile ? "1rem" : "1.2rem",
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: "1.6",
            opacity: "0.8",
            animation: "fadeInUp 0.8s ease-out 0.5s both"
          }}>
            Fresh additions to our luxury collection
          </p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: screenSize.isMobile ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(280px, 1fr))",
          gap: screenSize.isMobile ? "12px" : "24px",
          padding: screenSize.isMobile ? "0 10px" : "0 20px",
          maxWidth: "100%",
          margin: "0 auto 40px"
        }}>
          {newArrivals.map((product, index) => (
            <ProductCard
              key={product.id}
              product={product}
              index={index}
              section="new"
            />
          ))}
        </div>

        <div style={{ textAlign: "center" }}>
          <button 
            onClick={() => navigate("/products?sort=newest")}
            style={{
              background: "linear-gradient(135deg, #4ecdc4 0%, #44a08d 100%)",
              color: "white",
              border: "none",
              padding: screenSize.isMobile ? "15px 30px" : "18px 40px",
              borderRadius: "50px",
              fontSize: screenSize.isMobile ? "1rem" : "1.1rem",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
              boxShadow: "0 10px 30px rgba(78, 205, 196, 0.3)",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              position: "relative",
              overflow: "hidden"
            }}
            onMouseEnter={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = "translateY(-3px) scale(1.05)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(78, 205, 196, 0.4)";
              }
            }}
            onMouseLeave={(e) => {
              if (!screenSize.isMobile) {
                e.currentTarget.style.transform = "translateY(0) scale(1)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(78, 205, 196, 0.3)";
              }
            }}
          >
            View All New Arrivals
          </button>
        </div>
      </section>

      <Footer />

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes scaleIn {
            from {
              transform: scale(0.8);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
          
          @keyframes slideInFromTop {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes cardSlideUp {
            from {
              opacity: 0;
              transform: translateY(60px) scale(0.8);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
          
          @keyframes titleSlideIn {
            from {
              opacity: 0;
              transform: translateY(-30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes lineExpand {
            from {
              width: 0;
              opacity: 0;
            }
            to {
              width: 80px;
              opacity: 1;
            }
          }
          
          @keyframes pulse {
            0% {
              transform: scale(1);
              opacity: 0.7;
            }
            50% {
              transform: scale(1.1);
              opacity: 0.4;
            }
            100% {
              transform: scale(1);
              opacity: 0.7;
            }
          }

          .category-card:hover .category-overlay {
            opacity: 1 !important;
          }
          
          .category-card:hover .category-image {
            transform: scale(1.1) !important;
          }
          
          .category-card:hover .category-content {
            transform: translateY(0) !important;
            opacity: 1 !important;
          }

          @media (max-width: 768px) {
            .category-content {
              transform: translateY(0) !important;
              opacity: 1 !important;
            }
          }

          @media (prefers-reduced-motion: reduce) {
            * {
              animation-duration: 0.01ms !important;
              animation-iteration-count: 1 !important;
              transition-duration: 0.01ms !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default HomePage;
